import { httpClient } from "../utils/http.client";
import { API_ENDPOINTS } from "../config/api.config";

export const userService = {
  getUsers: async (params) => {
    return await httpClient.get(API_ENDPOINTS.USERS.LIST, { params });
  },

  getUserById: async (id) => {
    return await httpClient.get(`${API_ENDPOINTS.USERS.DETAIL}/${id}`);
  },

  createUser: async (userData) => {
    return await httpClient.post(API_ENDPOINTS.USERS.CREATE, userData);
  },

  updateUser: async (userData) => {
    const { user_id, ...userDataWithoutId } = userData;
    return await httpClient.put(
      `${API_ENDPOINTS.USERS.UPDATE}/${user_id}`,
      userDataWithoutId
    );
  },

  deleteUser: async (id) => {
    return await httpClient.delete(`${API_ENDPOINTS.USERS.DELETE}/${id}`);
  },

  bulkUploadUsers: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return await httpClient.post(API_ENDPOINTS.USERS.BULK_UPLOAD, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getUserRoles: async (userId) => {
    return await httpClient.get(API_ENDPOINTS.USERS.ROLES(userId));
  },
  getSearchUsers: async ({ identifier }) => {
    return await httpClient.get(API_ENDPOINTS.USERS.USER_SEARCH, {
      params: { identifier }
    });
  },
  resetPassword: async (userId) => {
    const url = API_ENDPOINTS.USERS.PASSWORD_RESET.replace("{userId}", userId);
    return await httpClient.post(url);
  },

  getUserEffectivePermissions: async (userId, roleId) => {
    return await httpClient.get(API_ENDPOINTS.USERS.EFFECTIVE_PERMISSIONS(userId), {
      params: { roleId }
    });
  },

  activateUser: async (userId) => {
    return await httpClient.post(API_ENDPOINTS.USERS.ACTIVATE(userId));
  },

  deactivateUser: async (userId, reason) => {
    return await httpClient.post(API_ENDPOINTS.USERS.DEACTIVATE(userId), { reason });
  },

  checkAvailability: async (field, value, excludeUserId) => {
    const params = { field, value };
    if (excludeUserId) params.excludeUserId = excludeUserId;
    return await httpClient.get(API_ENDPOINTS.USERS.CHECK_AVAILABILITY, { params });
  }
};
